<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1><font-awesome-icon icon="history"/> {{ $t('snaHistory') }}</h1>
        <p>{{ $t('snaHistoryDesc') }}</p>
      </div>
    </div>

    <b-tabs v-model="tabIndex">
      <b-tab>
        <template #title>
          <span class="sna-dot" style="background: #1877F2"></span> {{ $t('facebookHistory') }}
        </template>
        <facebook-history v-if="tabIndex === 0"></facebook-history>
      </b-tab>
      <b-tab>
        <template #title>
          <span class="sna-dot" style="background: #0068FF"></span> {{ $t('zaloOAHistory') }}
        </template>
        <zalo-o-a-history v-if="tabIndex === 1"></zalo-o-a-history>
      </b-tab>
      <b-tab>
        <template #title>
          <span class="sna-dot" style="background: #d81b60"></span> {{ $t('chatBotHistory') }}
        </template>
        <chat-bot-history v-if="tabIndex === 2"></chat-bot-history>
      </b-tab>
      <b-tab>
        <template #title>
          <span class="sna-dot" style="background: #607d8b"></span> {{ $t('chatSessionHistory') }}
        </template>
        <chat-session-history v-if="tabIndex === 3"></chat-session-history>
      </b-tab>
      <b-tab>
        <template #title>
          <span class="sna-dot" style="background: #25D366"></span> {{ $t('whatsappHistory') }}
        </template>
        <whatsapp-history v-if="tabIndex === 4"></whatsapp-history>
      </b-tab>
    </b-tabs>
  </main>
</template>

<script>
import FacebookHistory from "@/views/facebook/History.vue";
import ZaloOAHistory from "@/views/zalo-oa/History.vue";
import ChatBotHistory from "@/views/chatbot/History.vue";
import ChatSessionHistory from "@/views/chat-session/History.vue";
import WhatsappHistory from "@/views/message/WhatsappHistory.vue";

export default {
  components: { FacebookHistory, ZaloOAHistory, ChatBotHistory, ChatSessionHistory, WhatsappHistory },
  data() {
    return { tabIndex: 0 }
  },
  i18n: {
    messages: {
      en: {
        snaHistory: 'Social network accounts history',
        snaHistoryDesc: 'Changes log of social network accounts grouped by channel.',
        facebookHistory: 'Facebook',
        zaloOAHistory: 'Zalo OA',
        chatBotHistory: 'Chatbot',
        chatSessionHistory: 'Chat session',
        whatsappHistory: 'WhatsApp',
      },
      vi: {
        snaHistory: 'Lịch sử tài khoản mạng xã hội',
        snaHistoryDesc: 'Lịch sử thay đổi tài khoản MXH chia theo kênh.',
        facebookHistory: 'Facebook',
        zaloOAHistory: 'Zalo OA',
        chatBotHistory: 'Chatbot',
        chatSessionHistory: 'Phiên chat',
        whatsappHistory: 'WhatsApp',
      }
    }
  }
}
</script>

<style scoped>
.sna-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  vertical-align: middle;
}
</style>
